import Cookies from 'universal-cookie'
const cookies = new Cookies()

export function logOut() {
  const URL_LOGOUT_ALL_SYSTEM = (process.env.REACT_APP_AUTH_URL || "http://localhost:3000") + '/logout-all'
  cookies.remove('access_kho_token', { path: '/' })
  cookies.remove('user_info', { path: '/' })
  window.location.href = `${URL_LOGOUT_ALL_SYSTEM}?hethong=kho&redirect_url=${location.pathname}`
}

// get
export function getAccessToken() {
  return cookies.get('access_kho_token')
}

export function getUserInfo() {
  return cookies.get('user_info')
}

/** `id` user đăng nhập (cookie có thể là object hoặc chuỗi JSON) */
export function getCurrentUserId(): number | string | null {
  const raw = getUserInfo()
  if (raw == null || raw === '') return null
  try {
    const u = typeof raw === 'string' ? JSON.parse(raw) : raw
    return u?.id ?? null
  } catch {
    return null
  }
}

export function getProjectInfo() {
  return cookies.get('project_info')
}

export function getBranchInfo() {
  return cookies.get('branch_info')
} 

// set
export function saveAccessToken(value: string) {
  return cookies.set('access_kho_token', value, {
    path: '/',
  })
}


export function saveUserInfo(value: string) {
  return cookies.set('user_info', value, {
    path: '/',
  })
}

export function saveProjectInfo(value: string) {
  return cookies.set('project_info', value, {
    path: '/',
  })
}

export function saveBranchInfo(value: string) {
  return cookies.set('branch_info', value, {
    path: '/',
  })
}


export function isLoggedIn() {
  return !!getAccessToken()
}

const SUPER_ADMIN_ROLE = 'super_admin'

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.')
    if (parts.length < 2) return null
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return JSON.parse(atob(padded))
  } catch {
    return null
  }
}

export function getCurrentUserRole(): string | undefined {
  const token = getAccessToken()
  if (!token) return undefined
  const payload = decodeJwtPayload(token)
  const role = payload?.role
  return typeof role === 'string' ? role : undefined
}

export function isSuperAdminUser(): boolean {
  if (getCurrentUserRole() === SUPER_ADMIN_ROLE) {
    return true
  }
  const raw = getUserInfo()
  if (raw == null || raw === '') {
    return false
  }
  try {
    const u = typeof raw === 'string' ? JSON.parse(raw) : raw
    return u?.isSuperAdmin === true || u?.role === SUPER_ADMIN_ROLE
  } catch {
    return false
  }
}
